import PropTypes from 'prop-types';
import React from 'react';
import {
  ButtonToolbar,
  ButtonGroup,
  Button,
  MenuItem,
  DropdownButton,
  Modal,
  Row,
  Col
} from 'react-bootstrap';
import ProposalSendForm from './ProposalSendForm';

function findById(value) {
  return value.id === Number(this);
}
function findByContactId(value) {
  return value == Number(this);
}
// New Changes
function getInitialValues(jsonObject) {
  return jsonObject.map(item => (item.id));
}
function formatContactData(jsonObject) {
  return jsonObject.map(item => ({
    label: `${item.first_name} ${item.last_name} (${item.email})`,
    value: item.id,
  }));
}

class BrandContactsExpandCollapse extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			opened: false,
			checkedBrandContacts: [],
			showValidationError: false,
			errorText: '',
			name: '',
			email: '',
			newContactsList:null,
		}

		  this.initialValues = { contacts: getInitialValues(this.props.proposal.contacts) };
		  this.mergedContacts = this.props.newContact;
	    this.contactOptions = formatContactData(this.mergedContacts);

   		this.changeCheckBox = this.changeCheckBox.bind(this);
   		this.toggleCopyToBrandManager = this.toggleCopyToBrandManager.bind(this);
   		this.onNameChange = this.onNameChange.bind(this);
   		this.onEmailChange = this.onEmailChange.bind(this);
   		this.handleAddBrandContact = this.handleAddBrandContact.bind(this);
    	this.handleSubmit = this.handleSubmit.bind(this);
    	this.updateMergeValue = this.updateMergeValue.bind(this);
	}
    toggleCopyToBrandManager() {
    	if(this.props.proposal.brand){
    		this.setState({
    			opened:!this.state.opened
    		})
    	} else{
    		this.setState({
    			opened: this.state.opened
    		})
    	}
    }
	handleSubmit(values) {
	    this.props.handlePropasalRequest(values);
	}
	findContact(id) {
	    if (!this.props.proposal) {
	      return {};
	    }
	    const idx = this.props.proposal.saved_contacts.findIndex(findById, id);
	    if (idx === -1) {
	      console.log('Unable to find brand contact: ', id);
	      return { id };
	    }
	    return this.props.proposal.saved_contacts[idx];
  }

	onNameChange(event) {
    	this.setState({ name: event.target.value });
    }
    onEmailChange(event) {
    	this.setState({ email: event.target.value });
    }
    changeCheckBox(e) {
    	const id =  e.target.value;
    	const contact = this.findContact(id);
        const contactData = {'id': contact.id, 'email': contact.email, 'name': contact.username}
        let checkedBrandContactList = this.state.checkedBrandContacts;
        if(e.target.checked){
        	checkedBrandContactList.push(id);
        }else if(e.target.checked == false){
        	const idx = checkedBrandContactList.findIndex(findByContactId, id);
        	checkedBrandContactList.splice(idx, 1);
        }
        this.setState({
        	checkedBrandContacts: checkedBrandContactList
        })

        this.props.handleBrandContactData(contactData, e.target.checked)
    }
    handleAddBrandContact() {
    	if(this.state.name.trim() == '') {
			this.setState({showValidationError: true, errorText: 'Please provide a name'})
			return
		}else if(this.state.email.trim() == '') {
			this.setState({showValidationError: true, errorText: 'Please provide the email'})
			return
		}else if(this.state.email != '' && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(this.state.email)) {
			this.setState({showValidationError: true, errorText: 'Please provide the valid email address'})
			return
		}
		this.setState({showValidationError: false})
		this.props.addBrandContact(
			this.props.proposal.id,
		{
			name: this.state.name,
			email: this.state.email
		}
	  );
		this.setState({
			name: '',
			email: ''
		})
    }
    updateMergeValue(value){
    const data = value;
    this.setState({newContactsList:data})
    this.props.updateProposalState(data);
  }
	render() {
		const mergedContacts = this.props.newContact;
		const newContact = this.state.newContactsList?this.state.newContactsList:mergedContacts;
    const contactOptions = formatContactData(newContact);
    const options = contactOptions?contactOptions:this.contactOptions;
		
		const brandContacts = [];
		const checkedBrandContacts = this.state.checkedBrandContacts;
		const contacts = this.props.proposal.saved_contacts? this.props.proposal.saved_contacts : [];
		contacts.forEach(contact => {
			const isChecked = checkedBrandContacts.includes(String(contact.id)) ? true : false ;
			brandContacts.push(
				<div className="bid-hotel-contact">
					<input type='checkbox' value={contact.id} checked={isChecked} onChange={(e) => this.changeCheckBox(e)}/>&nbsp;&nbsp;
					{contact.email}&nbsp;{contact.is_sent && (<i className="fa fa-check bid-request-sent-icon" aria-hidden="true"/>)}
				</div>
				)
		})

		return(
			<div className="brand-contacts-section">
				<h3>
		          <i
		            className={this.state.opened ? 'fa fa-minus-square' : 'fa fa-plus-square'}
		            aria-hidden="true"
		            style={{cursor:this.props.proposal.brand?"pointer":"not-allowed"}}
		            onClick={this.toggleCopyToBrandManager}
		          />&nbsp;&nbsp;
		          Copy to Brand Manager
		        </h3>
		        <div className={this.state.opened ? 'show-element' : 'hide-element'}>
	              <ProposalSendForm
	                onSubmit={this.handleSubmit}
	                initialValues={this.initialValues}
	                options={options}
                	proposal={this.props.proposal}
                	showPopUp={this.props.showPopUp}
                	ContactPopUpShow={this.props.ContactPopUpShow}
                	ContactPopupHide={this.props.ContactPopupHide}
                	brandContacts={newContact}
                	HotelBrandContactUpdate={this.props.HotelBrandContactUpdate}
                	HotelBrandContactDelete={this.props.HotelBrandContactDelete}
                  updateProposalState={this.updateMergeValue}
                	sendProposal={this.props.sendProposal}
	                tab='hotel'
	              />
	           </div>
			</div>
		)
	}
};

export default BrandContactsExpandCollapse;


// WEBPACK FOOTER //
// src/routes/tours/components/BrandContactsExpandCollapse.js